require('./hireCardVirtualOnlyDebitView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @actions
const hireCardVirtualOnlyDebitActions = require('actions/hireCardVirtualOnlyDebit');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const profileActions = require('actions/profile');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const blockedAccountsAction = require('actions/blockedAccounts');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const HireCardVirtualOnlyDebitStep1 = require('components/hire/cardVirtualOnlyDebit/hireCardVirtualOnlyDebitStep1/hireCardVirtualOnlyDebitStep1');
const HireCardVirtualOnlyDebitStep2 = require('components/hire/cardVirtualOnlyDebit/hireCardVirtualOnlyDebitStep2/hireCardVirtualOnlyDebitStep2');
const HireCardVirtualOnlyDebitStep3 = require('components/hire/cardVirtualOnlyDebit/hireCardVirtualOnlyDebitStep3/hireCardVirtualOnlyDebitStep3');
const HireCardVirtualOnlyDebitSuccess = require('components/hire/cardVirtualOnlyDebit/hireCardVirtualOnlyDebitSuccess/hireCardVirtualOnlyDebitSuccess');
const HireCardVirtualOnlyDebitError = require('components/hire/cardVirtualOnlyDebit/hireCardVirtualOnlyDebitError/hireCardVirtualOnlyDebitError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');
// @constants
const {
    REDIRECT_URL,
    SECOND_STEP,
    VIRTUAL_DEBIT_CARD_PRODUCT_STANDARD,
    VIRTUAL_DEBIT_CARD_PRODUCT_SUBTYPE,
    VIRTUAL_DEBIT_CARD_PRODUCT_TYPE,
    WIZARD_FIRST_STEP,
} = require('constants/index');
const { HIRE_CARD_VIRTUAL_DEBIT } = require('constants/operationCodesAccounts');
const {
    VIRTUAL_DEBIT_CANCER_CARDART,
    VIRTUAL_DEBIT_PRIDE_CARDART,
    WEB_INACTIVE_ACCOUNT_ENABLED,
    MESSAGE_HIRE_24H
} = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require('components/hire/cardVirtualOnlyDebit/analytics/hireCardVirtualOnlyDebitAnalytics');

class HireCardVirtualOnlyDebitView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            getBlockedAccounts,
            getHireCardImages,
            immAccounts,
            immFlagBasedFeatures,
            match: { params: { redirect } },
            resetPrecontractualDocumentMail,
            validateStep,
        } = this.props;
        let cardImageIds = ['B.506.012.001'];

        resetPrecontractualDocumentMail();

        if (immFlagBasedFeatures.get(VIRTUAL_DEBIT_CANCER_CARDART)) {
            cardImageIds = ['B.506.012.004'];
        } else if (immFlagBasedFeatures.get(VIRTUAL_DEBIT_PRIDE_CARDART)) {
            cardImageIds = ['B.506.012.003'];
        }

        getHireCardImages(cardImageIds);
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_VIRTUAL_DEBIT)

        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
    }

    componentWillUnmount() {
        const {
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props
        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();
        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
        }
    }

    getProcessDetail() {
        return `${VIRTUAL_DEBIT_CARD_PRODUCT_TYPE}.${VIRTUAL_DEBIT_CARD_PRODUCT_SUBTYPE}`;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardVirtualOnlyDebit } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardVirtualOnlyDebit.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardVirtualOnlyDebit,
            immProfile,
        } = this.props;
        const selectedAccount = immHireCardVirtualOnlyDebit.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardVirtualOnlyDebitSuccess
                    immAccount={immAccount}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCardVirtualOnlyDebit={immHireCardVirtualOnlyDebit}
                    immProfile={immProfile}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    buildWizardHiringSteps() {
        const {
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardVirtualOnlyDebit,
            immAccounts,
            immFlagBasedFeatures,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardVirtualOnlyDebit,
            immHireInformation,
            immHiringProductInformation,
            immPdfData,
            immPreContractualMail,
            immShippingAddressList,
            immProfile,
            requestPDFMerge,
            requestProfile,
            sendPreContractualMail,
            sendPrecontractualDocumentMail,
            setAllAccountsToInactive,
            setTermsAndCondsText,
            setVisibleStep,
            setWillCancel,
            validateStep
        } = this.props;
        const wizardActions = {
            cancel: this.handleCancel,
            finish: hireCardVirtualOnlyDebit,
            setVisibleStep,
            setWillCancel,
            validateStep
        };

        const sendMailParams = {
            type: VIRTUAL_DEBIT_CARD_PRODUCT_TYPE,
            subType: VIRTUAL_DEBIT_CARD_PRODUCT_SUBTYPE,
            standar: VIRTUAL_DEBIT_CARD_PRODUCT_STANDARD,
        };
        const showPreLeaveModal = this.isReady();
        const immSteps = immHireCardVirtualOnlyDebit.get('steps');
        const operativeName = __CONTACT_CENTER__ ? "operatives-virtualOnlyDebitCard" : undefined;

        const productName = this.getProcessDetail();
        const tealiumData = [
            catalogue[analyticsId.VIRTUAL_ONLY_DEBIT_CARD_STEP_1_VIEW]({ productName }),
            catalogue[analyticsId.VIRTUAL_ONLY_DEBIT_CARD_STEP_2_VIEW]({ productName }),
            catalogue[analyticsId.VIRTUAL_ONLY_DEBIT_CARD_STEP_3_VIEW]({ productName }),
        ];
        const loadingFlag = immHireCardVirtualOnlyDebit.get('loadingFlag');
        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealiumData[immHireCardVirtualOnlyDebit.get('visibleStep') - 1]}
                        visibleStep={immHireCardVirtualOnlyDebit.get('visibleStep')}
                        wizardClass="hire-card-virtual-only-debit__wizard"
                        isTaggingSecondVersion
                    >
                        <WizardStep
                            isLoading={loadingFlag}
                            cancelButton={true}
                            position="first"
                        >
                            <HireCardVirtualOnlyDebitStep1
                                flagBasedFeatures={immFlagBasedFeatures}
                                gestorCrossEnabled={immFlagBasedFeatures.get('web-gc-enabled')}
                                hireCmsKey="virtual-only-debit"
                                immHireInformation={immHireInformation}
                                immHiringProductInformation={immHiringProductInformation}
                                contractName="virtual-only-debit"
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                immHireCardVirtualOnlyDebit={immHireCardVirtualOnlyDebit}
                                immPreContractualMail={immPreContractualMail}
                                immProfileFields={immProfile}
                                requestPDFMerge={requestPDFMerge}
                                requestProfile={requestProfile}
                                sendMailParams={sendMailParams}
                                sendPreContractualMail={sendPreContractualMail}
                                setTermsAndCondsText={setTermsAndCondsText}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardVirtualOnlyDebitStep2
                                handleAccountChange={handleAccountChange}
                                immAccounts={immAccounts}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCardVirtualOnlyDebit={immHireCardVirtualOnlyDebit}
                                isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                                setAllAccountsToInactive={setAllAccountsToInactive}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            immFinalButton={'hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_hire'}
                            isLoading={immHireCardVirtualOnlyDebit.get('isFetching')}
                            onBackClick={false}
                            position="last"
                        >
                            <HireCardVirtualOnlyDebitStep3
                                immAccounts={immAccounts}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCardVirtualOnlyDebit={immHireCardVirtualOnlyDebit}
                                immProfile={immProfile}
                                immPdfData={immPdfData}
                                sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                operativeName={operativeName}
                                setTermsAndCondsText={setTermsAndCondsText}
                            />
                        </WizardStep>
                    </Wizard>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                immAccounts={immAccounts}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immShippingAddressList={immShippingAddressList}
                                immProfile={immProfile}
                                selectedAccount={immSteps.getIn([SECOND_STEP, 'accountId'])}
                                type="prepaid"
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardVirtualOnlyDebit, immFlagBasedFeatures } = this.props;
        const pageTitle = formatText('hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_pageTitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText('hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_breadcrumb')
            }
        ];

        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardVirtualOnlyDebit.getIn(['steps', WIZARD_FIRST_STEP-1, 'hireRestriction']);
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);

        let content;
        if (immHireCardVirtualOnlyDebit.get('error')) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardVirtualOnlyDebitError
                        immHireCardVirtualOnlyDebit={immHireCardVirtualOnlyDebit}
                        processDetail={processDetail}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardVirtualOnlyDebitError
                        immHireCardVirtualOnlyDebit={immHireCardVirtualOnlyDebit}
                        processDetail={processDetail}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        } else if (immHireCardVirtualOnlyDebit.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else if (immHireCardVirtualOnlyDebit.get('allAccountsInactive')) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <InactiveAccountsError
                        navigateToBackButtonText={'cards'}
                        navigateToBackButtonURL={'cards'}
                    />
                </div>
            );
        }
        else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-virtual-only-debit">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardVirtualOnlyDebitView.propTypes = {
    getHireCardImages: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardVirtualOnlyDebit: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardVirtualOnlyDebit: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object.isRequired,
    match: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetPrecontractualDocumentMail: PropTypes.func,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports.constructor = HireCardVirtualOnlyDebitView;
module.exports.HireCardVirtualOnlyDebitView = connect(
    state => ({
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireCardVirtualOnlyDebit: state.hireCardVirtualOnlyDebit,
        immHireInformation: state.hireInformation,
        immHiringProductInformation: state.hiringProductInformation,
        immPdfData: state.precontractualsMergePdfs,
        immPreContractualMail: state.preContractualMail,
        immProfile: state.profile,
        immShippingAddressList: state.shippingAddress,
    }),
    {
        getHireCardImages: hireCardImageSelectorActions.getHireCardImages,
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        handleAccountChange: hireCardVirtualOnlyDebitActions.setAccount,
        handleAgreementCheckboxChange: hireCardVirtualOnlyDebitActions.setAgreementCheckbox,
        hireCardVirtualOnlyDebit: hireCardVirtualOnlyDebitActions.hireCardVirtualOnlyDebit,
        requestProfile: profileActions.requestProfile,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        reset: hireCardVirtualOnlyDebitActions.reset,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        setAllAccountsToInactive: hireCardVirtualOnlyDebitActions.setAllAccountsToInactive,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireCardVirtualOnlyDebitActions.setVisibleStep,
        setWillCancel: hireCardVirtualOnlyDebitActions.setWillCancel,
        validateStep: hireCardVirtualOnlyDebitActions.validateStep,
    }
)(withRouter(HireCardVirtualOnlyDebitView));
